import { useEffect, useState } from 'react';

/** Below this width the strip is one bar (design r5, the Studio narrow layout of q4). */
export const STUDIO_WORK_NARROW_QUERY = '(max-width: 699.98px)';

function matches(): boolean {
  return (
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia(STUDIO_WORK_NARROW_QUERY).matches
  );
}

/** True below 700 px: a phone, a narrow window, the Studio web view of the native apps. */
export function useIsNarrowScreen(): boolean {
  const [narrow, setNarrow] = useState(matches);
  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return undefined;
    }
    const query = window.matchMedia(STUDIO_WORK_NARROW_QUERY);
    const update = () => setNarrow(query.matches);
    update();
    query.addEventListener?.('change', update);
    return () => query.removeEventListener?.('change', update);
  }, []);
  return narrow;
}
